import { DOCUMENT_COLORS } from 'src/global/constants';

const getDocumentColor = (index: number): string => {
  return index > DOCUMENT_COLORS.length ? '#ffffff' : DOCUMENT_COLORS[index];
};

export default getDocumentColor;
